import axios from 'axios';

const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (
    typeof window !== 'undefined' &&
    (window.location.hostname.includes('ondigitalocean.app') ||
      window.location.hostname.includes('services.knls.in'))
  ) {
    return '/api';
  }
  return 'http://localhost:3000/api';
};

const API_BASE_URL = getApiBaseUrl();

const authHeaders = () => {
  const token = localStorage.getItem('student_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const LEADERBOARD_CATEGORIES = [
  { id: 'overall', label: 'Overall', icon: '🏆', color: '#F59E0B' },
  { id: 'videos', label: 'Videos', icon: '▶️', color: '#EF4444' },
  { id: 'notes', label: 'Notes', icon: '📖', color: '#10B981' },
  { id: 'flashcards', label: 'Flashcards', icon: '🃏', color: '#8B5CF6' },
  { id: 'quiz', label: 'Quiz', icon: '❓', color: '#3B82F6' },
  { id: 'coding', label: 'Hands-on', icon: '💻', color: '#06B6D4' },
  { id: 'assignments', label: 'Assignments', icon: '📝', color: '#F97316' },
  { id: 'speed_blitz', label: 'Speed Blitz', icon: '⚡', color: '#F59E0B' },
  { id: 'key_pop', label: 'Key Pop', icon: '🫧', color: '#A855F7' },
  { id: 'type_racer', label: 'Type Racer', icon: '🏃', color: '#2563EB' },
  { id: 'typing', label: 'Daily Typing', icon: '⌨️', color: '#6366F1' },
];

export const LEADERBOARD_PERIODS = [
  { id: 'today', label: 'Today' },
  { id: 'week', label: 'This Week' },
  { id: 'month', label: 'This Month' },
  { id: 'all', label: 'All Time' },
];

export async function fetchLeaderboardCourses() {
  const response = await axios.get(`${API_BASE_URL}/lms-progress/leaderboard/courses`, {
    headers: authHeaders(),
  });
  return response.data;
}

export async function fetchLmsLeaderboard(courseCode, { category = 'overall', period = 'week' } = {}) {
  const response = await axios.get(
    `${API_BASE_URL}/lms-progress/leaderboard/${encodeURIComponent(courseCode)}`,
    {
      headers: authHeaders(),
      params: { category, period },
    },
  );
  return response.data;
}

export function formatLeaderboardValue(categoryId, primaryValue, secondaryValue, meta = {}) {
  switch (categoryId) {
    case 'videos':
      return {
        primary: `${primaryValue} lessons`,
        secondary: `${secondaryValue}h watched`,
      };
    case 'notes':
      return {
        primary: `${primaryValue} notes`,
        secondary: `${secondaryValue}h studied`,
      };
    case 'flashcards':
      return {
        primary: `${primaryValue} mastered`,
        secondary: `${secondaryValue} practiced`,
      };
    case 'quiz':
      return {
        primary: `${primaryValue}% best`,
        secondary: `${secondaryValue} quizzes`,
      };
    case 'coding':
    case 'assignments':
      return {
        primary: `${primaryValue} marks`,
        secondary: `${secondaryValue} completed`,
      };
    case 'speed_blitz':
    case 'key_pop':
    case 'type_racer':
      return {
        primary: `${primaryValue} WPM`,
        secondary: `${secondaryValue}% accuracy`,
      };
    case 'typing':
      return {
        primary: `Score ${primaryValue}`,
        secondary: `${secondaryValue} WPM`,
      };
  }
  return {
    primary: `${primaryValue} XP`,
    secondary: `${secondaryValue} activities`,
  };
}
